<template>
  <div :class="`swiper-${_uid}`">
    <div class="swiper-wrapper">
      <slot />
    </div>

    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import Swiper, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";

export default {
  props: {
    slidesPerView: {
      type: Number,
      default: 1
    },
    spaceBetween: {
      type: Number,
      default: 16
    },
    loop: {
      type: Boolean,
      default: false
    },
    centeredSlides: {
      type: Boolean,
      default: false
    },
    breakpoints: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    const swiper = new Swiper(`.swiper-${this._uid}`, {
      modules: [Navigation],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: this.slidesPerView,
      spaceBetween: this.spaceBetween,
      loop: this.loop,
      centeredSlides: this.centeredSlides,
      breakpoints: this.breakpoints
    });
  }
};
</script>
